import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Adsense } from "@ctrl/react-adsense";

import { useDispatch, useSelector } from "react-redux";
import { AdsenseAccount } from "constants/config";
import { showAds } from "utils/ads";
import { RootState } from "stores/Store";
import { isMobile } from "react-device-detect";
import { isProOrHigher, PRO_FEATURES_ENABLED } from "interfaces/user";
import { openCheckout } from "utils/stripe";
import { setShowNavbar, setShowFriends } from "../stores/uiState/UiStateSlice";

function Home() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.userReducer.user);
  useEffect(() => {
    dispatch(setShowNavbar(true));
    dispatch(setShowFriends(true));
  }, []);

  return (
    <section className="Home">
      <div className="heroContainer">
        <div className="headerContainer">
          <h1 className="title">Drafter</h1>
          <h2 className="headline">
            The first League of Legends drafting game
          </h2>
        </div>
        <div className="descriptionContainer">
          <h2 className="description">
            <b>League of Legends</b> fans have been discussing <b>drafts</b>{" "}
            since the beginning of the esport scene... It&apos;s about time they{" "}
            <b>put their own skills to the test!</b> Here comes the first
            drafting game where anyone can show their drafting ability and even
            climb a competitive drafting ladder.
          </h2>
        </div>
      </div>
      <div className="tryGameContainer">
        <h2 className="tryGameCatchPhrase">Try the game now!</h2>
        <div className="buttonWrapper">
          <motion.button
            className="tryGameButton"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => navigate("/lobby")}
          >
            Play
          </motion.button>
          <motion.button
            className="tryGameButton"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => navigate("/lab")}
          >
            Train
          </motion.button>
        </div>
        {showAds(user) && (
          <Adsense
            client={AdsenseAccount}
            slot={isMobile ? "5279432204" : "9863584592"}
            style={{
              display: "inline-block",
              marginTop: "0.5em",
              width: isMobile ? "300px" : "100%",
              height: "100px",
            }}
            format={isMobile ? "" : "rectangle"}
          />
        )}
        <div className="featuresContainer">
          <div className="featureItem">
            <h3 className="featureTitle">Data-Driven Predictions</h3>
            <p className="featureDescription">
              Our algorithm analyzes champion synergies, counter-matchups, and
              meta trends based on historical competitive data to predict win
              probabilities with precision.
            </p>
          </div>
          <div className="featureItem">
            <h3 className="featureTitle">Competitive Ladder</h3>
            <p className="featureDescription">
              Climb the ranked ladder with our Elo-based rating system. Compete
              against other players, track your progress, and prove you have the
              best drafting instincts.
            </p>
          </div>
          <div className="featureItem">
            <h3 className="featureTitle">Multiple Game Modes</h3>
            <p className="featureDescription">
              Play Matchmaking or Friendly matches. Practice solo in Simulation
              mode or sharpen your skills in the Drafting Lab with instant
              feedback.
            </p>
          </div>
        </div>
      </div>
      {PRO_FEATURES_ENABLED && user && !isProOrHigher(user) && (
        <div className="proContainer">
          <div className="proContent">
            <h3 className="proTitle">Unlock Unlimited Analyses</h3>
            <p className="proDescription">
              Free accounts are limited to 5 analyses per day. Go Pro for
              unlimited access.
            </p>
            <motion.button
              className="proButton"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={openCheckout}
            >
              Upgrade to Pro — 4.99€/mo
            </motion.button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Home;
